<template>
  <div class="row">
    <div class="col s12">
        <p>
            <ul class="tabs" ref="tabs">
                <li class="tab s4"><a href="#activities">Activities</a></li>
                <li class="tab s4"><a href="#programs">Programs</a></li>
                <li class="tab s4"><a href="#skills">Skills</a></li>
            </ul>
        </p>
    </div>
    <ActivityList id="activities" class="col s12" :user="user" />
    <ProgramList id="programs" class="col s12" :user="user" />
    <SkillList id="skills" class="col s12" :user="user" />

</div>
</template>

<script>
import M from 'materialize-css'
import api from '@/api'
import ProgramList from '@/components/coach/ProgramList'
import SkillList from '@/components/coach/SkillEdit'
import ActivityList from '@/components/coach/ActivityList'

export default {
  name: 'coach',
  props: ['tab'],
  components: { ProgramList, SkillList, ActivityList },
  data: function () {
    return {
      user: undefined
    }
  },
  created () {
    this.user = api.getCurrentUser()
  },
  mounted () {
    var tabs = M.Tabs.init(this.$refs.tabs, {})
    if (this.tab) tabs.select(this.tab)
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Coach.vue